import { InternalLinkRecord } from '@/graphql/types'

export enum LinkType {
	Solution = 'SolutionRecord',
	Article = 'ArticleRecord',
	Industry = 'IndustryRecord',
	Service = 'ServiceRecord',
	LandingPage = 'LandingPageRecord',
	Company = 'CompanyRecord',
	Process = 'ProcessRecord',
	Category = 'CategoryRecord',
	Product = 'ProductRecord',
	SubCategory = 'SubCategoryRecord',
	Legal = 'LegalRecord',
	CustomFooter = 'CustomFooterRecord',
	CustomHeader = 'CustomHeaderRecord',
	GetAQuote = 'GetAQuoteRecord',
}

export const urlsPrefix = {
	[LinkType.Solution]: '/solutions/',
	[LinkType.Article]: '/articles/',
	[LinkType.LandingPage]: '/landing-pages/',
	[LinkType.Industry]: '/industries/',
	[LinkType.Service]: '/services/',
	[LinkType.Company]: '/company/',
	[LinkType.Process]: '/products/processes/',
	[LinkType.Category]: '/c/',
	[LinkType.Product]: '/p/',
	[LinkType.SubCategory]: '/products/series/',
	[LinkType.Legal]: '/legal/',
	[LinkType.GetAQuote]: '/get-a-quote/',
	default: '/',
}

/**
 *
 * @param link InternalLinkRecord
 */
export default function getUrlPrefix(link: InternalLinkRecord) {
	if (!link.link) {
		console.log('link-error', link)
		return ''
	}
	if (!link.link.__typename) {
		console.log('link.link.__typename is null or undefined', link)
		return ''
	}
	const urltype: string = urlsPrefix[link.link.__typename] || urlsPrefix.default
	const url = urltype + (link.link.slug || '')
	return `${url}${link.anchor ? `#spy_${link.anchor}` : ''}`
}
